import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
		list: [],
        pager: {},
        loading: false,
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 获取付款流水列表
		async getCashList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
                url: '/client/cash',
                params
			})
			commit('setState',{key:'list',data: res.docs})
			commit('setState',{key:'pager',data: {limit: res.limit,total: res.total}})
            commit('setState',{key:'loading',data: false})
		},
		async modifyCash({}, data: any) {
			return fetch({
				url: `/client/cash/${data._id}`,
				method: 'put',
				data,
			})
		}
	}
}